import o from "react";
import { useTranslation as l } from "react-i18next";
import { useAuth as r } from "../../../../../auth/hooks/useAuth.js";
import { useNavigation as g } from "../../hooks/useNavigation.js";
import t from "./requiresLoginPage.module.scss.js";
function f() {
  const {
    navigationConfig: {
      common: e
    }
  } = g(), {
    login: n
  } = r(), { t: i } = l();
  function a() {
    n();
  }
  return /* @__PURE__ */ o.createElement(
    "div",
    {
      style: {
        "--backgroundColor": (e == null ? void 0 : e.design.background) ?? "#FFF",
        "--textColor": (e == null ? void 0 : e.design.text) ?? "#000"
      },
      className: t.loginPage
    },
    /* @__PURE__ */ o.createElement("div", { className: t.loginPage__prelude }, i("loginPage.prelude")),
    /* @__PURE__ */ o.createElement(
      "div",
      {
        onClick: () => a(),
        className: t.loginPage__callToAction
      },
      i("loginPage.callToAction")
    )
  );
}
export {
  f as RequiresLoginPage
};
//# sourceMappingURL=RequiresLoginPage.js.map
